import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: {
    initialized: boolean;
} = {
    initialized: false
};

const posthogSlice = createSlice({
    name: 'posthog',
    initialState,
    reducers: {
        setPosthogInitialized: (state, action: PayloadAction<boolean>) => {
            state.initialized = action.payload;
        }
    }
});

export const { setPosthogInitialized } = posthogSlice.actions;
export default posthogSlice;
